var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 240,
    viewBox: "0 0 408 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6631_165240)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.08,
    cx: 199.244,
    cy: 119.397,
    rx: 100,
    ry: 140,
    transform: "rotate(-60 199.244 119.397)",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 120,
    width: 264,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 144,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 159,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 160,
    r: 20,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 32,
    width: 264,
    height: 80,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 56,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 71,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 72,
    r: 20,
    fill: "#E8E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6631_165240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 240,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.0114c93072c9c3c095baf92d4a51b9e7.svg";
export { ForwardRef as ReactComponent };